import React, { useState, useContext, useEffect } from "react"
import _ from "lodash"
import PropTypes from 'prop-types'
import SweetAlert from "react-bootstrap-sweetalert";

function Alert(props) {

   let { isSuccess, isError, isWarning, title, show, showCancelBtn, handelConfirm, handelCancel, msg, confirmBtnText, cancelBtnText } = props

   return show ? (
      <SweetAlert
         success={isSuccess}
         error={isError}
         warning={isWarning}
         title={title}
         onConfirm={handelConfirm}
         onCancel={handelCancel}
         confirmBtnBsStyle="info sm"
         cancelBtnBsStyle="danger"
         confirmBtnText={confirmBtnText}
         cancelBtnText={cancelBtnText}
         showCancel={showCancelBtn}
         btnSize='md'
         style={{ zIndex: 10000 }}
         // style={{ display: "block", marginTop: "-100px" }}
      >{msg}</SweetAlert>
   ) : null
}

export default Alert

Alert.propTypes = {
   show: PropTypes.bool,
   isSuccess: PropTypes.bool,
   isError: PropTypes.bool,
   isWarning: PropTypes.bool,
   showCancelBtn: PropTypes.bool,
   title: PropTypes.string,
   msg: PropTypes.string,
   cancelBtnText: PropTypes.string,
   confirmBtnText: PropTypes.string,
   handelConfirm: PropTypes.func,
   handelCancel: PropTypes.func,
}

Alert.defaultProps = {
   isSuccess: false,
   isError: false,
   isWarning: false,
   showCancelBtn: false,
   msg: null,
   handelCancel: () => { },
}